import React, { useState } from "react";
import DynamicForm from "./DynamicForm";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import { ControlPoint } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";

const conditionInitialState = { field: "", operator: "", values: [] };

const ConditionList = ({
  businessUnit,
  condition,
  conditionDynamicFields,
  addMoreCondition,
  handleResetProcessor,
  processors,
  availablePsp,
}) => {
  const { fields, addField, removeField, updateField, setFields, resetFields } = conditionDynamicFields;
  const [loader, setLoader] = useState(false);
  

  const addCondition = async () => {
    setLoader(true);
    const isValid = await addMoreCondition();
    setLoader(false);
    if (isValid) {
      addField(conditionInitialState);
    }
  };

  
  return (
    <>
      {businessUnit && fields?.length > 0 && (
        <>
          {fields?.map((field, index) => (
            <DynamicForm
              key={index}
              field={field}
              index={index}
              updateField={updateField}
              condition={condition}
              removeField={removeField}
              fields={fields}
              setFields={setFields}
              processors={processors}
              handleResetProcessor={handleResetProcessor}
              resetFields={resetFields}
              addMoreCondition={addMoreCondition}
            />
          ))}
          {fields?.length < condition?.length && availablePsp?.length > 0 && (
            <div className="mb-4" style={{ position: "relative" }}>
              <div className="timelineSeparator ">
                {loader ? (
                  <CircularProgress sx={{ color: "#403E9F" }} size={14} />
                ) : (
                  <ControlPoint sx={{ color: "#403E9F", fontSize: "16px" }} />
                )}
              </div>
              <span
                onClick={() => {
                  if (!loader) addCondition();
                }}
                style={{
                  color: "#403E9F",
                  fontSize: "14px",
                  cursor: "pointer",
                  display: "inline-block",
                }}
              >
                Add More Condition
              </span>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ConditionList;
